<app-dashboard-header></app-dashboard-header>

<main>
  <div class="container">
    <h2 class="mt-5">الدورات التدريبية</h2>
    <table class="table table-bordered table-hover mt-5 mb-5">
      <thead class="thead-dark">
        <tr>
          <th>اسم الدورة التدربية</th>
          <th>الوصـــف</th>
          <th>الصـــورة</th>
          <th>القســـم</th>
          <th>العمليــات</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let course of courses; let i = index" style="cursor: pointer;" routerLink="/getCourseById/{{course._id}}">
          <td>{{ course.tittle }}</td>
          <td>{{ course.description }}</td>
          <td><img src="https://khairokom-uploadfiles.azurewebsites.net/files/{{course.image}}" width="100px" height="auto" /></td>
          <td>{{ course.categoryID }}</td>
          <td>
            <a class="update btn btn-light" routerLink="/updateCourse/{{ course._id }}">التعديــــل</a>
            <a class="delete btn btn-secondary" (click)="delete(course._id)"
              >الحـــذف</a>            
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</main>

<app-dashboard-footer></app-dashboard-footer>
